import {useState, useEffect} from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Form, Button, Row, Col} from 'react-bootstrap';
import   {useDispatch, useSelector}  from 'react-redux';
import Loader from '../components/Loader';
import Message from '../components/Message.js';
import { getUserDetails, updateUser } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js';
import { USER_UPDATE_RESET } from '../constants/userConstants';

const UserEditScreen = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    let params = useParams();
    const userId = params.id;
  
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] =useState(false);
    
    const userDetails = useSelector(state => state.userDetails);
    const {loading, error, user} = userDetails;

    const userUpdate = useSelector(state => state.userUpdate);
    const {loading: loadingUpdate, error: errorUpdate, success: successUpdate} = userUpdate;
    
    useEffect(() => {
        if(successUpdate){
            dispatch({type: USER_UPDATE_RESET})
            navigate('/admin/userlist')
        }else{
    //because this would mean the successUpdate is not true
            if(!user.name || user._id !== userId){
                dispatch(getUserDetails(userId))
            }else{
                setName(user.name)
                setEmail(user.email)
                setIsAdmin(user.isAdmin)
            }
        }
       
    }, [dispatch, userId, user, successUpdate, navigate])
    
    const submitHandler = (e) => {
      e.preventDefault()
      dispatch(updateUser({
        _id: userId, 
        name, 
        email, 
        isAdmin
      }))
    }
  
      return (
        <>
         
        <FormContainer>
        <Row>
          <Col md={8} className="mx-0">
            <button onClick={() => navigate(-1)}>&#8592;</button>
          </Col>
        </Row>
        <h1>Edit User</h1>
        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant='danger'>{errorUpdate}</Message> }
        {loading ? <Loader /> : error ? <Message variant='danger'>{error}</Message>
        : (
<Form onSubmit = {submitHandler}>
        <Form.Group controlId= 'name'>
            <Form.Label>Name</Form.Label>
            <Form.Control 
              type='name' 
              placeholder='Enter name' 
              value={name} 
              onChange={(e) => setName(e.target.value)}>
            </Form.Control>
          </Form.Group>
  
          <Form.Group controlId= 'email'>
            <Form.Label>Email Address</Form.Label>
            <Form.Control 
              type='email' 
              placeholder='Enter Email' 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId= 'isAdmin'>
            <Form.Check 
              type='checkbox' 
              label="Is Admin"
              checked={isAdmin}
              onChange={(e) => setIsAdmin(e.target.checked)}>
            </Form.Check>
          </Form.Group>
  
          <Button type='submit' variant='primary' className='mt-2 customButtons'>
            Update
          </Button>
        </Form>
        )}
        
      </FormContainer>
  
        </>
    )
  }

export default UserEditScreen